import { useRef, useState } from 'react';
import { format } from 'date-fns';
import { useOverlayContext } from 'seagull';
import { useIoContext, useStore, useStoreActions } from '~/contexts';
import { useLocaleKeys } from '~/i18n';
import { selectors } from '~/store/state-selectors';
export const EXPORT_CLIENTS_CSV_ERROR_TOAST_TESTID = 'export-clients-csv-error-toast';
export function useExportClientsCsv() {
    const { t: clientsPageTexts } = useLocaleKeys('pages.clientsDashboard');
    const businessId = useStore(selectors.user.businessId);
    const { api } = useStoreActions();
    const { browser: { downloadCsv }, getNow } = useIoContext();
    const { showErrorToast } = useOverlayContext();
    const [exportingAll, setExportingAll] = useState(false);
    const [exportingSelected, setExportingSelected] = useState(false);
    const exportInFlight = useRef(false);
    function exportFileName() {
        return "anchor_clients_export_".concat(format(getNow(), 'yyyy-MM-dd'), ".csv");
    }
    async function handleExportAll() {
        if (businessId == null || exportInFlight.current) {
            return;
        }
        exportInFlight.current = true;
        setExportingAll(true);
        try {
            const csv = await api.client.exportAllClientsCsv();
            downloadCsv(csv, exportFileName());
        } catch (unused) {
            showErrorToast(clientsPageTexts.exportError(), EXPORT_CLIENTS_CSV_ERROR_TOAST_TESTID);
        } finally{
            exportInFlight.current = false;
            setExportingAll(false);
        }
    }
    async function handleExportSelected(ids) {
        if (ids.length === 0 || exportInFlight.current) {
            return;
        }
        exportInFlight.current = true;
        setExportingSelected(true);
        try {
            const csv = await api.client.exportClientsCsvByIds(ids);
            downloadCsv(csv, exportFileName());
        } catch (unused) {
            showErrorToast(clientsPageTexts.exportError(), EXPORT_CLIENTS_CSV_ERROR_TOAST_TESTID);
        } finally{
            exportInFlight.current = false;
            setExportingSelected(false);
        }
    }
    return {
        exportingAll,
        exportingSelected,
        handleExportAll,
        handleExportSelected
    };
}
